import React from "react";
import {
    BulletList,
    BulletListAdd,
    NoteStackAdd,
    OfflineBolt,
    AnimatedImages,
    DragClick,
    AddBusiness,
} from "@dippi/icons";

interface SectionIconProps {
    id: string;
}

const SectionIcon: React.FC<SectionIconProps> = ({ id }) => {
    switch (id) {
        case "product_info_section":
            return <BulletList />;
        case "extended_info_section":
        case "technical_data_section":
        case "storage_section":
            return <BulletListAdd />;
        case "ingredients_section":
        case "ingredients_beverages_section":
            return <NoteStackAdd />;
        case "nutrition_section":
            return <OfflineBolt />;
        case "media_section":
            return <AnimatedImages />;
        case "description_section":
            return <DragClick />;
        case "stores_section":
            return <AddBusiness />;
        default:
            return null;
    }
};

export default SectionIcon;
